<template>
  <Layout>
    <div style="width: 100%; margin-top: 55px;">
      <div class="header">
        <div class="flex justify-between">
          <h6>Depreciation Overrides</h6>
          <q-btn color="green" @click="$store.commit('depreciationOverrides/SET_CREATE_MODAL', {show: true})">
            <i class="fas fa-plus"></i>
          </q-btn>
        </div>
        <div class="row">
          <div class="col col-xs-12 col-sm-6 col-md-3" style="padding-right: 5px;">
            <q-select v-model="filterSelectedCompany"
                      :options="companies"
                      clearable
                      label="Company"
                      @input="locationsList"
                      :disable="filterLoading"/>
          </div>
          <div class="col col-xs-12 col-sm-6 col-md-3" style="padding-right: 5px;">
            <q-select v-model="filterSelectedLocation"
                      :options="locations"
                      clearable
                      label="Location"
                      :disable="filterLoading || !filterSelectedCompany"/>
          </div>
          <div class="col col-xs-12 col-sm-6 col-md-3" style="padding-right: 5px;">
            <q-select v-model="filterSelectedMake"
                      :options="makes"
                      clearable
                      label="Make"
                      @input="modelsList"
                      :disable="filterLoading"/>
          </div>
          <div class="col col-xs-12 col-sm-6 col-md-3">
            <q-select v-model="filterSelectedModel"
                      :options="models"
                      clearable
                      label="Model"
                      :disable="filterLoading || !filterSelectedMake"/>
          </div>
        </div>
      </div>
      <q-card class="flexbox justify-between " style="min-height: 250px">
        <div v-if="count > 0 && !loading">
          <q-table
            ref="table"
            :data="items"
            :columns="columns"
            row-key="name"
            :pagination="{page: 1, rowsPerPage: 0}"
            hide-bottom
            class="no-shadow"
          >
            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td key="company" :props="props" style="width: 25%">
                  <span style="font-weight: bold">
                    {{ props.row.company.name }}
                  </span>
                </q-td>
                <q-td key="location" :props="props" style="width: 25%">
                  <span style="font-weight: bold">
                    {{ props.row.location.name }}
                  </span>
                </q-td>
                <q-td key="make" :props="props" style="width: 25%">
                  <span style="text-transform: capitalize; font-weight: bold">
                    {{ props.row.make.name }}
                  </span>
                </q-td>
                <q-td key="model" :props="props" style="width: 25%">
                  <span style="text-transform: capitalize; font-weight: bold">
                    {{ props.row.model.name }}
                  </span>
                </q-td>
                <q-td key="value" :props="props" style="width: 25%">
                  <span style="text-transform: capitalize; font-weight: bold">
                    {{ props.row.value }}%
                  </span>
                </q-td>
                <q-td key="id" :props="props">
                  <q-btn size="sm"
                         @click="$store.commit('depreciationOverrides/SET_EDIT_MODAL', {show: true, id: props.row.id})"
                         class="q-mr-sm icon"
                         color="secondary">
                    <i class="fas fa-pen fa-fw"></i>
                  </q-btn>
                  <q-btn size="sm"
                         @click="deleteItemConfirm = {id: props.row.id}"
                         class="q-mr-sm icon"
                         color="red">
                    <i class="fas fa-trash fa-fw"></i>
                  </q-btn>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
        <div class="flex justify-center" style="min-height: 250px;" v-if="count === 0 && !loading">
          <p class="self-center" style="position:relative; height: 100%">Data not found.</p>
        </div>
        <div class="flex justify-center" style="min-height: 250px;" v-if="loading">
          <p class="self-center">
            <q-spinner-facebook size="45px" color="primary" />
          </p>
        </div>
        <div class="q-pa-lg flex flex-center" v-if="!this.loading && this.pagination.last > 1">
          <q-pagination
            v-model="pagination.page"
            :max="pagination.last"
            :max-pages="5"
            @input="depreciationOverridesList"
            boundary-numbers
            direction-links
          />
        </div>
      </q-card>
    </div>
    <depreciation-override-create-modal :update-table="depreciationOverridesList"/>
    <depreciation-override-edit-modal :update-table="depreciationOverridesList"/>
    <q-dialog v-model="deleteItemConfirm.id !== null" persistent @keydown.esc="deleteItemConfirm.id = null">
      <q-card>
        <q-card-section class="row items-center">
          <span class="q-ml-sm">Are you sure you want to delete?</span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="No" color="primary" v-close-popup @click="deleteItemConfirm.id = null"/>
          <q-btn flat label="Yes" color="red" v-close-popup @click="deleteItem(deleteItemConfirm.id)"/>
        </q-card-actions>
      </q-card>
    </q-dialog>
  </Layout>
</template>

<script>
import Layout from '../components/Layout'
import axios from '../axios/index'
import Loading from "@/components/Loading.vue";
import DepreciationOverrideCreateModal from "@/components/DepreciationOverrideCreateModal.vue";
import DepreciationOverrideEditModal from "@/components/DepreciationOverrideEditModal.vue";

export default {
  components: {
    DepreciationOverrideCreateModal,
    DepreciationOverrideEditModal,
    Loading,
    Layout
  },

  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        per: 10,
        last: 0,
      },
      count: 0,
      columns: [
        {name: 'company', label: 'Company', field: 'company'},
        {name: 'location', label: 'Location', field: 'location'},
        {name: 'make', label: 'Make', field: 'make'},
        {name: 'model', label: 'Model', field: 'model'},
        {name: 'value', label: 'Value', field: 'value'},
        {name: 'id', label: 'Actions', field: 'id'}
      ],
      items: [],
      filterLoading: false,
      companies: [],
      filterSelectedCompany: null,
      locations: [],
      filterSelectedLocation: null,
      makes: [],
      filterSelectedMake: null,
      models: [],
      filterSelectedModel: null,
      deleteItemConfirm: {
        id: null,
      },
    }
  },
  mounted() {
    this.companiesList()
    this.locationsList()
    this.makesList()
    this.depreciationOverridesList()
  },
  methods: {
    async companiesList() {
      try {
        this.filterLoading = true
        const {data} = await axios.get('/companies')
        this.companies = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.filterLoading = false
        this.filterSelectedLocation = null
      }
    },
    async locationsList() {
      try {
        this.filterLoading = true
        this.locations = []
        this.filterSelectedLocation = null
        let params = {}
        if (this.filterSelectedCompany) {
          params.company = this.filterSelectedCompany.value
        }
        this.filterLoading = true
        const {data} = await axios.get('/locations', {
          params
        })
        this.locations = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.filterLoading = false
      }
    },
    async makesList() {
      try {
        this.filterLoading = true
        const {data} = await axios.get('/vehicle-brands')
        this.makes = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.filterLoading = false
      }
    },
    async modelsList() {
      if (!this.filterSelectedMake) {
        this.models = []
        this.filterSelectedModel = null
        return
      }

      try {
        this.filterLoading = true
        const {data} = await axios.get('/vehicle-models/' + this.filterSelectedMake.value)
        this.models = data.data.map(item => {
          return {
            value: item.id,
            label: item.name
          }
        })
      } catch (err) {
        console.log(err)
      } finally {
        this.filterLoading = false
      }
    },
    async depreciationOverridesList() {
      this.loading = true
      this.items = []
      try {
        let params = {
          per: this.pagination.per,
          page: this.pagination.page,
        }
        if (this.filterSelectedCompany) {
          params.company_id = this.filterSelectedCompany.value
        }
        if (this.filterSelectedLocation) {
          params.location_id = this.filterSelectedLocation.value
        }
        if (this.filterSelectedMake) {
          params.brand_id = this.filterSelectedMake.value
        }
        if (this.filterSelectedModel) {
          params.model_id = this.filterSelectedModel.value
        }
        const {data} = await axios.get('/depreciation-overrides', {
          params
        })

        this.pagination.last = data.data.pagination.last
        this.count = data.data.count

        if (data.data.items.length > 0) {
          for (const key in data.data.items) {
            this.items.push({
              company: data.data.items[key].location.company,
              location: data.data.items[key].location,
              make: data.data.items[key].vehicle_model.brand,
              model: data.data.items[key].vehicle_model,
              value: data.data.items[key].value,
              created_at: data.data.items[key].created_at,
              updated_at: data.data.items[key].updated_at,
              id: data.data.items[key].id
            })
          }
        }
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
      } finally {
        this.loading = false
      }
    },
    async deleteItem(id) {
      try {
        this.loading = true
        await axios.delete('/depreciation-override/' + id)
        this.$q.notify({
          message: 'Successfully deleted.',
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'positive'
        })
        await this.depreciationOverridesList()
      } catch (err) {
        this.$q.notify({
          message: err.message,
          timeout: 250,
          position: 'top-right',
          progress: true,
          type: 'negative'
        })
      } finally {
        this.loading = false
        this.deleteItemConfirm.id = null
      }
    }
  },
  computed: {
    reFetch: {
      get() {
        return this.$store.state.depreciationOverrides.reFetch
      },
      set(value) {
        this.$store.commit('depreciationOverrides/SET_REFETCH', value)
      }
    }
  },
  watch: {
    filterSelectedLocation: function (newVal, oldVal) {
      this.depreciationOverridesList()
    },
    filterSelectedModel: function (newVal, oldVal) {
      this.depreciationOverridesList()
    },
    '$store.state.depreciationOverrides.reFetch': {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.depreciationOverridesList()
        }
      }
    },
  },
}
</script>

<style scoped>
h6 {
  margin: 0 0 10px;
}
.header {
  position: relative;
  display: block;
  margin-bottom: 10px;
}
td > span {
  font-weight: normal !important;
}
.icon {
  padding: 0;
  width: 32px;
  height: 32px;
}
</style>
